// 📄 components/StepMGProject.tsx
import React from 'react';
import { GeneralsFormData } from '../../../../../services/commerce/integrationService.ts';

interface StepMGProjectProps {
  mgProjectId: string;
  mgSystemId: string;
  onChange: (field: keyof GeneralsFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepMGProject({
  mgProjectId,
  mgSystemId,
  onChange,
  isInvalid
}: StepMGProjectProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-purple-500/5 border border-purple-500/10 rounded-xl p-3 space-y-1">
        <span className="text-[10px] font-bold text-purple-400 uppercase tracking-widest block">SAP Integration Suite, Managed Gateway</span>
        <p className="font-mono text-xs text-gray-300">
          <span>Managed Gateway → My Projects → Create Project</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-purple-400">1. Creación de Proyecto e Identificadores CIG</h3>
        <p className="text-sm text-gray-400 mt-1">
          Registra el ID del Proyecto y el System ID asignado dentro del portal de Managed Gateway (CIG) para este entorno de integración.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            CIG Project ID <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={mgProjectId}
            onChange={(e) => onChange('mgProjectId', e.target.value.toUpperCase())}
            placeholder="ej. PRJ-987654"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-purple-500 ${
              isInvalid && !mgProjectId ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            SAP System ID (Logical Reference) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={mgSystemId}
            onChange={(e) => onChange('mgSystemId', e.target.value.toUpperCase())}
            placeholder="ej. QS4CLNT100 o ERP_PRD"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-purple-500 ${
              isInvalid && !mgSystemId ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>
      </div>
    </div>
  );
}
